import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const WriteFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M21.32 2.62C21.76 3.08 21.8 3.82 21.32 4.28L20.4 5.18L18.7 3.56L19.64 2.62C20.12 2.14 20.84 2.16 21.32 2.62ZM11.58 10.8L10.62 13.28L13.22 12.46L19.88 5.72V19.84H4.12V4.08H18.22L11.58 10.8Z" />
    </SvgIcon>
  );
});
